import { useEffect, useState } from "react";
import { Menu } from "lucide-react";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
  SheetTitle,
} from "@/components/ui/sheet";
import { NAV_LINKS } from "@/data/content";

export default function Navbar({ onConsult }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "border-b border-white/5 bg-noir/90 backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10">
        <a href="/#home" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src="/assets/mk-logo.jpg"
            alt="MK Group Plus LLC"
            className="h-11 w-11 rounded-full border border-gold/30 object-cover"
          />
          <span className="hidden font-serif text-lg tracking-[0.25em] text-cream sm:block">
            MK <span className="text-gold">GROUP PLUS</span>
          </span>
        </a>

        <nav className="hidden items-center gap-9 lg:flex" data-testid="nav-links">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm font-medium tracking-wide text-cream/70 transition-colors duration-300 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="nav-consultation-btn"
            onClick={() => onConsult()}
            className="btn-gold hidden !px-6 !py-2.5 lg:inline-flex"
          >
            Book Free Consultation
          </button>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button
                data-testid="mobile-menu-btn"
                className="text-cream lg:hidden"
                aria-label="Open menu"
              >
                <Menu className="h-7 w-7" />
              </button>
            </SheetTrigger>
            <SheetContent
              side="right"
              className="w-80 border-l border-gold/20 bg-noir"
            >
              <SheetTitle className="sr-only">Menu</SheetTitle>
              <div className="mt-12 flex flex-col gap-7">
                {NAV_LINKS.map((l) => (
                  <a
                    key={l.href}
                    href={l.href}
                    data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                    onClick={() => setOpen(false)}
                    className="font-serif text-2xl text-cream transition-colors duration-300 hover:text-gold"
                  >
                    {l.label}
                  </a>
                ))}
                <button
                  data-testid="mobile-nav-consultation-btn"
                  onClick={() => {
                    setOpen(false);
                    onConsult();
                  }}
                  className="btn-gold mt-6"
                >
                  Book Free Consultation
                </button>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
